module.exports = __webpack_public_path__ + "static/img/14.3d858d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/sp/14.png
// module id = lJWb
// module chunks = 0